const copyWithFallback = (text: string) => {
  if (typeof document === 'undefined' || !document.body) {
    throw new Error('Clipboard is unavailable');
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);

  try {
    textarea.select();

    // eslint-disable-next-line @typescript-eslint/no-deprecated -- fallback for Safari Clipboard API failures
    if (!document.execCommand('copy')) {
      throw new Error('Failed to copy to clipboard');
    }
  } finally {
    textarea.remove();
  }
};

export const copyToClipboard = async (text: string) => {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // Safari can reject Clipboard API writes even after a user interaction.
    }
  }

  copyWithFallback(text);
};

export const copyPromiseToClipboard = async (text: Promise<string>) => {
  if (
    typeof navigator !== 'undefined' &&
    navigator.clipboard?.write &&
    typeof ClipboardItem !== 'undefined'
  ) {
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/plain': text.then(
            (value) => new Blob([value], { type: 'text/plain' }),
          ),
        }),
      ]);
      return;
    } catch {
      // Fall back when the browser rejects the asynchronous Clipboard API write.
    }
  }

  await copyToClipboard(await text);
};
